// TODO: 应该根据ps的资源定义，迁移到common/enums/
export enum IvAssetType {
  Video = 'video',
  Audio = 'audio',
  Text = 'text',
  Hand = 'hand',
  Image = 'image',
  SequenceFrame = 'sequenceFrame',
  DragonBone = 'dragonBone',
  Particle = 'particle',
}

export enum IvSegmentType {
  Video = 'video',
  Audio = 'audio',
  Freeze = 'freeze',
  Loop = 'loop',
  Hold = 'hold',
  Text = 'text',
  Image = 'image',
  Hand = 'hand',
}

export enum IvLoopSubType {
  Single = 'single', // 单向循环
  Double = 'double', // 双向循环
}

export enum IvTrackType {
  Video = 'video',
  Audio = 'audio',
  Iv = 'iv',
  Text = 'text',
  Image = 'image',
  Hand = 'hand',
}

export enum IvPreviewState {
  Playing = 'playing',
  Pause = 'pause',
  Loading = 'loading',
}
